export const CREDIT_MEMO = "credit-memo"
export const CREDIT_MEMOS = "credit-memos"



// WEBPACK FOOTER //
// ./src/state/credit-memo/Constants.ts